import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';

import { SessionStaffing, SessionStaffingService } from '../../../_services';
import { SessionStaffingArchivedPipe, SessionStaffingSearchPipe } from './pipe';

@Component({
    selector: 'virtual-session-list-component',
    templateUrl: 'staffing.component.html',
    styleUrls: ['staffing.component.scss'],
    providers: [
        TranslatePipe,
        SessionStaffingArchivedPipe,
        SessionStaffingSearchPipe,
    ],
})
export class SessionStaffingComponent implements OnInit {
    error: string;
    success: string;
    virtualSessions: SessionStaffing[];
    archived: boolean = false;
    search: string = '';

    constructor(private sessionStaffingService: SessionStaffingService) {}

    ngOnInit() {
        this.sessionStaffingService
            .findAll()
            .subscribe((virtualSessionsMap) => {
                this.virtualSessions = virtualSessionsMap;
            });
    }

    archivedClicked() {
        this.archived = !this.archived;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/staffing/staffing.component.ts